module.exports = __webpack_public_path__ + "media/images/athletes/2024-8b1651cdda55ae4b2e682484ce9ada3a.png";